import Promise from 'bluebird';

export default class NotificationReady {
  makeReady(notificationNumber) {
    this.initializeSingletonPromise();
    this.resolveCallBack(notificationNumber);
  }

  ready() {
    this.initializeSingletonPromise();
    return this.readyPromise;
  }

  reset() {
    this.readyPromise = null;
  }

  initializeSingletonPromise() {
    if (this.readyPromise) {
      return;
    }
    this.readyPromise = new Promise((resolve) => {
      this.resolveCallBack = resolve;
    });
  }
}
